import { IContextualMenuItem } from '@fluentui/react/lib/components/ContextualMenu/ContextualMenu.types';
import loc from 'owa-localize';
import {
    allFilterText,
    appointmentsFilterText,
    organizerFilterText,
    attendeeFilterText,
    acceptedFilterText,
} from 'owa-calendar-shared-strings/lib/strings/calendarSurfaceCommandBar.locstring.json';
import {
    filterOnClick,
    allFilterOnClick,
    getDefaultCurrentFilters,
    CalendarEventsFilters,
} from 'owa-calendar-events-filter';

export function getNonCategoryMenuItems(): IContextualMenuItem[] {
    const currentFilters = getDefaultCurrentFilters();
    return [
        {
            key: allFilterText,
            text: loc(allFilterText),
            title: loc(allFilterText),
            canCheck: true,
            checked: currentFilters.includes(CalendarEventsFilters.All),
            onClick: allFilterOnClick,
        },
        {
            key: appointmentsFilterText,
            text: loc(appointmentsFilterText),
            title: loc(appointmentsFilterText),
            canCheck: true,
            checked: currentFilters.includes(CalendarEventsFilters.Appointments),
            onClick: (
                event?: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
                item?: IContextualMenuItem
            ) => {
                filterOnClick(CalendarEventsFilters.Appointments);
            },
        },
        {
            key: organizerFilterText,
            text: loc(organizerFilterText),
            title: loc(organizerFilterText),
            canCheck: true,
            checked: currentFilters.includes(CalendarEventsFilters.Organizer),
            onClick: (
                event?: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
                item?: IContextualMenuItem
            ) => {
                filterOnClick(CalendarEventsFilters.Organizer);
            },
        },
        {
            key: attendeeFilterText,
            text: loc(attendeeFilterText),
            title: loc(attendeeFilterText),
            canCheck: true,
            checked: currentFilters.includes(CalendarEventsFilters.Attendee),
            onClick: (
                event?: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
                item?: IContextualMenuItem
            ) => {
                filterOnClick(CalendarEventsFilters.Attendee);
            },
        },
        {
            key: acceptedFilterText,
            text: loc(acceptedFilterText),
            title: loc(acceptedFilterText),
            canCheck: true,
            checked: currentFilters.includes(CalendarEventsFilters.Accepted),
            onClick: (
                event?: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
                item?: IContextualMenuItem
            ) => {
                filterOnClick(CalendarEventsFilters.Accepted);
            },
        },
    ];
}
